module.exports = __webpack_public_path__ + "static/media/times-circle-solid.bb7daa97.svg";